import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Modal } from 'antd';
import { useModalWidth } from '../../hooks/useModalWidth';
import { scrollTriggerIntoView } from '../../util/modalUtils';
import SuccessImg from '../../assets/UiElements/correct.svg';

// Error/Failure icon SVG component
const ErrorIcon = () => (
  <svg width="97" height="96" viewBox="0 0 97 96" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="48.5" cy="48" r="40" fill="#F44336"/>
    <path d="M32.5 32L64.5 64" stroke="white" strokeWidth="6" strokeLinecap="round"/>
    <path d="M64.5 32L32.5 64" stroke="white" strokeWidth="6" strokeLinecap="round"/>
  </svg>
);

export default function PaymentSuccess() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const modalWidth = useModalWidth();

  // Get any query params from Hubtel if needed
  const reference = searchParams.get('reference') || searchParams.get('ref');
  const paymentStatus = searchParams.get('status');
  
  // Log for debugging (can be removed later)
  console.log('Payment success params:', { reference, status: paymentStatus });

  useEffect(() => {
    scrollTriggerIntoView();
  }, []);

  const handleClose = () => {
    // Navigate to dashboard or transactions page
    navigate('/dashboard');
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      background: '#f5f6fa', 
      display: 'flex', 
      alignItems: 'center', 
      justifyContent: 'center',
      padding: 24 
    }}>
      <Modal
        centered
        open={true}
        destroyOnClose={true}
        closable={false}
        footer={null}
        onCancel={handleClose}
        width={modalWidth}
        zIndex={4000}
      >
        <div className="p-5">
          <div className="success-modal" style={{ textAlign: 'center' }}>
            <div style={{ marginBottom: 16 }}>
              <img src={SuccessImg} alt="Success" style={{ width: 80, height: 80 }} />
            </div>
            <p className="lead mt-4" style={{ fontWeight: 700, fontSize: 20, margin: '24px 0 8px 0' }}>
              Payment Successful!
            </p>
            <p className="text-black-50" style={{ color: '#555', marginBottom: 24 }}>
              Your payment has been processed successfully. Thank you for your payment.
              {reference && (
                <span style={{ display: 'block', marginTop: 8, fontSize: 14, color: '#888' }}>
                  Reference: {reference}
                </span>
              )}
            </p>
            <button 
              className="btn btn-primary mb-4 w-50 mobile-full-width" 
              onClick={handleClose}
              style={{ borderRadius: 50, padding: '12px 28px', fontWeight: 600 }}
            >
              Go to Dashboard
            </button>
          </div>
        </div>
      </Modal>
    </div>
  );
}

// Also export the error icon for reuse in PaymentCancel
export { ErrorIcon };
